export default __webpack_public_path__ + "90d03b7718fde93d787334ae45f283f3.wasm";